import React, { useState } from "react";
import { addComment } from "../../services/commentService";
import { CreateCommentDto } from "../../types/comment";
import { useUser } from "../../contexts/UserContext";
import { TiUserOutline } from "react-icons/ti";

interface CommentFormProps {
  photoId: number;
  onCommentAdded: () => void;
}

const CommentForm: React.FC<CommentFormProps> = ({ photoId, onCommentAdded }) => {
  const [content, setContent] = useState("");
  const { user, handleFetchAvatar } = useUser();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!content.trim()) return;
    await addComment({ photoId, content } as CreateCommentDto);
    setContent("");
    onCommentAdded();
  };

  const handleClear = () => {
    setContent("");
  };

  return (
    <form className="custom-form max-w-sm mx-auto" onSubmit={handleSubmit}>
      <div className="flex justify-center mb-2">
        {user?.avatar &&
          <img
            className="w-16 h-16 bg-gray-300 rounded-full mb-4 border border-gray-400 shadow-sm"
            src={user.avatar}
            alt="user avatar"
            onError={() => handleFetchAvatar(user.userId)}
          />
        }
        {!user?.avatar &&
          <TiUserOutline className="w-16 h-16 text-white mb-4 border rounded-full border-gray-400 shadow-sm" />
        }
      </div>

      <textarea
        id="commentInput"
        rows={1}
        placeholder="Leave a comment..."
        value={content}
        onChange={(e) => {
          if (e.target.value.length <= 255) {
            setContent(e.target.value);
          }
        }}
        onInput={(e) => {
          const target = e.target as HTMLTextAreaElement;
          if (target.value.length <= 255) {
            target.style.height = "auto";
            target.style.height = target.scrollHeight + "px";
          }
        }}
      ></textarea>

      {content.trim() && (
        <div className="flex items-center justify-between mt-2 gap-2">
          <button
            type="button"
            className="custom-btn min-w-[80px]"
            data-btn-type="negative"
            onClick={handleClear}
          >
            Clear
          </button>

          <div className="flex items-center justify-center h-10 px-2 text-sm text-accentAlt whitespace-nowrap">
            {content.length}/255
          </div>

          <button
            type="submit"
            className="custom-btn min-w-[80px]"
          >
            Post
          </button>
        </div>
      )}


    </form>
  );
};

export default CommentForm;
